const pagesSettingsSettingsEn = {
  authentication: {
    mfa: {
      card: {
        description: 'Choose account types to require MFA when signing in.',
        edit: 'Edit',
        requiredAccountTypes: 'Required account types:',
        title: 'Email',
      },
      deleteDialog: {
        continueButton: 'Continue',
        description:
          'Removing the MFA requirement will significantly impact account security. Please confirm if you want to continue to save changes.',
        discardChangesButton: 'Discard changes',
        title: 'Are you sure to remove MFA requirement?',
      },
      description:
        'Multi-Factor Authentication (MFA) adds an extra layer of security by asking users to confirm their identity in more than one way.',
      editDialog: {
        cancelButton: 'Cancel',
        description: 'Choose account types to require MFA when signing in.',
        saveButton: 'Save',
        title: 'Editing MFA',
      },
      mfaMethod: {
        email: 'Email',
      },
      title: 'MFA',
      userType: {
        individual: 'Member',
        operator: 'Staff',
      },
    },
    title: 'Authentication',
  },
  loginEmailPolicy: {
    card: {
      edit: 'Edit',
      reset: 'Reset to unconfigured',
      title: 'Personal Email Login Policy',
    },
    description:
      'Configure whether personal email addresses can be used for login, separately for staff and member accounts.',
    editDialog: {
      cancelButton: 'Cancel',
      description:
        'Configure whether personal email addresses can be used for login, separately for staff and member accounts.',
      error: 'An error occurred while saving changes. Please try again.',
      saveButton: 'Save',
      title: 'Edit Personal Email Login Policy',
    },
    loadError: 'Could not load login email policy settings.',
    mode: {
      alwaysAllowed: {
        label: 'Personal email can always be used for login',
      },
      disallowed: {
        label: 'Personal email cannot be used for login',
      },
      unset: {
        effectiveHint:
          'When not configured, this organization policy does not apply and sign-in with a personal email address is allowed.',
        label: 'Not configured',
      },
      untilWorkEmailSet: {
        label:
          'Personal email can only be used for login while a work email is not set',
      },
    },
    retry: 'Retry',
    target: {
      individual: 'Member',
      operator: 'Staff',
    },
    title: 'Personal Email Login Policy',
    toast: {
      updateSuccess: 'Policy updated.',
    },
  },
  navigation: {
    authentication: 'Authentication',
    sso: 'SSO Connections',
  },
  sso: {
    addConnection: 'Add connection',
    card: {
      domains: 'Target domains',
      status: 'Status',
    },
    delete: 'Delete',
    deleteDialog: {
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      description:
        'This will also remove all associated domain settings. Users with these domains will no longer be able to sign in via SSO.',
      title: 'Delete SSO connection?',
    },
    description:
      "Configure Single Sign-On (SSO) to enable login through your organization's identity provider.",
    disabled: 'Disabled',
    domains: 'Domains',
    edit: 'Edit',
    editDialog: {
      addDomain: 'Add domain',
      allDeleteButton: 'Delete all data?',
      cancelButton: 'Cancel',
      createTitle: 'Add SSO Connection',
      domainPlaceholder: 'e.g. acme.com',
      domainsDescription:
        'Specify the email domains for users who will sign in via SSO.',
      domainsLabel: 'Target domains',
      editTitle: 'Edit SSO Connection',
      enabledLabel: 'Enable SSO',
      removeDomainAriaLabel: 'Remove {{domain}}',
      saveButton: 'Save',
    },
    enabled: 'Enabled',
    noConnections: 'No SSO connections configured',
    noDomains: 'No domains configured',
    title: 'SSO Connections',
    toast: {
      deleteSuccess: 'SSO connection deleted successfully',
      saveSuccess: 'SSO connection saved successfully',
    },
    validation: {
      duplicateDomain: 'This domain is already added',
      invalidDomain: 'Please enter a valid domain format',
      issuerIdentifierRequired: 'This field is required',
    },
  },
};

export default pagesSettingsSettingsEn;
